import { useEffect, useState } from 'react'
import { useAuth0 } from '@auth0/auth0-react'
import { useMutation } from '@tanstack/react-query'

const useApiPost = <TVars, TData>(queryFunction: Function) => {
  const [accessToken, setAccessToken] = useState<string>()
  const { user, isAuthenticated, getAccessTokenSilently } = useAuth0()

  useEffect(() => {
    const getToken = async () => {
      try {
        const accessToken = await getAccessTokenSilently()
        setAccessToken(accessToken)
      } catch (_error) {
        console.warn('[useApiPost] call - No valid accessToken.')
        setAccessToken(undefined)
      }
    }

    if (isAuthenticated) {
      getToken()
    }
  }, [getAccessTokenSilently, isAuthenticated])

  return useMutation<TData, any, TVars, any>({
    mutationFn: (variables: TVars) => queryFunction(accessToken, user?.sub, variables),
    retry: 1,
  })
}

export default useApiPost
